import { render, staticRenderFns } from "./WordlistDialog.vue?vue&type=template&id=06a61f16&scoped=true&"
import script from "./WordlistDialog.vue?vue&type=script&lang=js&"
export * from "./WordlistDialog.vue?vue&type=script&lang=js&"
import style0 from "./WordlistDialog.vue?vue&type=style&index=0&id=06a61f16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a61f16",
  null
  
)

export default component.exports